<template>
    <div style="background-color:#ffffe4;" v-if="factsheet.info.credits_applied.length == 0">
        <div class="container" style="padding-top:5px;padding-bottom:5px;margin-top:0px;border:1px solid #ccc;font-size:0.8em;border:2px solid #84ba45;background-color:#f5ffe3;padding:20px 15px;">
            <div class="row align-items-center">
                <div class="col-8" style="border-right:0px solid #ffd152;padding:0px 10px;color:#444;">
                    <p>This free factsheet will <strong>expire automatically and be removed on 14 August 2025</strong>.</p>
                    <p style="color:#444;margin-top:14px;">You can upgrade this factsheet to <strong><span style="background-color:#84ba45;font-weight:600;color:#fff;padding:1px 4px;border-radius:3px;">Pro</span></strong> for <strong>1 credit</strong> and unlock the following features:</p>
                    <ul class="feature-list">
                        <li>Extend the expiry date by one year</li>
                        <li>Enable data downloads and other advanced features</li>
                        <li>Support our mission by covering hosting and development costs</li>
                        </ul>
                </div>
                <div class="col-4 text-center" style="color:#000;padding-top:0px;">
                    <UpgradeModal v-bind:factsheet="factsheet" />
                    <a href="/features/" style="display:inline-block;;margin-top:14px;">Check out the features in Geofolio Pro</a>
                </div>
            </div>
            

        </div>

        <div class="container" style="padding-top:5px;padding-bottom:5px;margin-top:15px;background-color:#ffffe4;border:1px solid #ccc;font-size:0.8em;border:2px solid #ffd152;color:rgb(68, 68, 68);display:none;">
            <p><strong>Thanks for trying out Geofolio!</strong><p>
            <p>This is a free area of interest that will <strong>expire on 14 August 2025</strong>. The owner of this report can upgrade with <a href="/features/">Geofolio Pro</a> to keep it around a while longer and unlock advanced tools and experimental features.</p>
        </div>

    </div>
</template>

<script>


import UpgradeModal from "@/components/modals/UpgradeModal.vue";

export default {
    name: 'Upgrade',
    components:{ UpgradeModal },
    props: ['location', 'factsheet', 'loaded'],
    data() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    mounted() {
    }
}
</script>

<style scoped>
    p {
        margin-bottom:7px;
        margin-top:7px;
    }
    ul {
        margin-bottom:7px;
        margin-top:7px;
        
        padding-left:18px;
    }
    ul.feature-list li {
        margin:0px;
        padding:2px 0px;
        color:rgb(68, 68, 68)
    }
</style>